// import dependency to handle HTTP request to our back end
import axios from 'axios'
import Vuex from 'vuex'
import Vue from 'vue'

//load Vuex
Vue.use(Vuex);

// S T A T E 
const state = {
  posts: [],
  filteredPosts: [],
  filter: {
    collection: [],
    typ: [],
    subproject: [],
    author: [],
    responsible: [],
    tag: [],
  }
}

// 1. A C T I O N S
// they are triggering the MUTATIONS
// those guys change data asynchonous
const actions = {
  // the basic api call
  async getPosts({ commit }, { qp }) {
    let search_query = 'section: "ddb"';
    if(qp != '') {
      search_query = 'search: "'+qp+'"';
    }
    await axios.post('https://pia-ddn.dhlab.unibas.ch/api', {
      query: `
        query {
          ddb:entries(${search_query}) {
            title
            author {
              id
              fullName
            }
            ... on ddb_ddb_Entry {
              quarter
              slug
              uid
              subtitle
              collection
              subproject
              tags {
                id
                title
              }
              typ
              quarter
              responsible {
                id
                fullName
              }
            }
          }
        }
      `
    })
      .then(response => {
        // console.log(response.data.data.ddb)
        // after sucessfull call, set the posts in the mutations
        console.log(response)
        commit('SET_POSTS', response.data.data.ddb)
      })
  },
  async filteredPosts ({ commit }) {
    // C. call the filter magic
    await commit('FILTER_POSTS')
  },
  async filterCollection ({ commit, dispatch }, collection) {
    // A. take the 'subproject' from the clicked button and set it to the subproject filter
    await commit('SET_FILTER_COLLECTION', collection)
    // B. call async filteredPosts below 
    await dispatch('filteredPosts')
  },
  async filterTyp ({ commit, dispatch }, author) {
    await commit('SET_FILTER_TYP', author)
    await dispatch('filteredPosts')
  },
  async filterSubproject ({ commit, dispatch }, subproject) {
    await commit('SET_FILTER_SUBPROJECT', subproject)
    await dispatch('filteredPosts')
  },
  async filterAuthor ({ commit, dispatch }, author) {
    await commit('SET_FILTER_AUTHOR', author)
    await dispatch('filteredPosts')
  },
  async filterResponsible ({ commit, dispatch }, responsible) {
    await commit('SET_FILTER_RESPONSIBLE', responsible)
    await dispatch('filteredPosts')
  },
  async filterTag ({ commit, dispatch }, tag) {
    await commit('SET_FILTER_TAG', tag)
    await dispatch('filteredPosts')
  },
}

// 2. M U T A T I O N S
// those guys change the state in a synchonous way,  
const mutations = {
  // set the posts and the filteredPosts
  SET_POSTS(state, posts) {
    state.posts = posts,
    state.filteredPosts = posts
  },
  // Toggles a recieved filter to the subproject array in the state above
  SET_FILTER_COLLECTION(state, collection) {
    state.filter.collection.includes(collection) ? state.filter.collection.splice(state.filter.collection.indexOf(collection), 1) : state.filter.collection.push(collection)
  },
  SET_FILTER_TYP(state, typ) {
    state.filter.typ.includes(typ) ? state.filter.typ.splice(state.filter.typ.indexOf(typ), 1) : state.filter.typ.push(typ)
  },
  SET_FILTER_SUBPROJECT(state, subproject) {
    state.filter.subproject.includes(subproject) ? state.filter.subproject.splice(state.filter.subproject.indexOf(subproject), 1) : state.filter.subproject.push(subproject)
  },
  SET_FILTER_AUTHOR(state, author) {
    state.filter.author.includes(author) ? state.filter.author.splice(state.filter.author.indexOf(author), 1) : state.filter.author.push(author)
  },
  SET_FILTER_RESPONSIBLE(state, responsible) {
    state.filter.responsible.includes(responsible) ? state.filter.responsible.splice(state.filter.responsible.indexOf(responsible), 1) : state.filter.responsible.push(responsible)
  },
  SET_FILTER_TAG(state, tag) {
    state.filter.tag.includes(tag) ? state.filter.tag.splice(state.filter.tag.indexOf(tag), 1) : state.filter.tag.push(tag)
  },
  FILTER_POSTS (state) {
    let filterArray = [...state.posts]
    let resultArray = []
    console.log("start filtering")

    // filter trough all state.filters and return if something matches
    let filterParameters = Object.entries(state.filter);
    filterArray.filter((entry) =>  {
      return filterParameters.forEach(([key, permitted]) => {
        return permitted.some((e) => {
          // make shure that what you check is an array by concating it
          // adjust here based on key for different data structures!
          let checkThis = [];
          if (key === 'author') {
            checkThis = checkThis.concat(entry.author.fullName)
          } else if(key === 'responsible') {
            entry.responsible.forEach(responsible => {
              checkThis.push(responsible.fullName)
            });
          } else if(key === 'tag') {
            entry.tags.forEach(tag => {
              checkThis.push(tag.title)
            });
          } else {
            checkThis = checkThis.concat(entry[key])
          }
          // now look at all elements in the array an compare it to "e" (allowed ones)
          return checkThis.some((target) => {
            // console.log("type: ", key, "check this: ", checkThis, "includes? ", e, "target: ", target, e.includes(target))
            if(e.includes(target)){
              resultArray.push(entry)
            }
          })
        })
      })
    })

    // if we found something return it, else return all
    if (resultArray.length > 0){
      state.filteredPosts = resultArray 
    } else {
      state.filteredPosts = filterArray 
    }
  }
}


// G E T T E R S 
// basically what you would write in 'computed'
const getters = {
  // returns all filters from the state
  filter: state => {
    return state.filter
  },
  // returns the results from state.filteredPosts which gets mutated by the action FILTER_POSTS
  filteredPosts: state => {
    return state.filteredPosts.filter(post => post != null)
  },
  // compute your buttons!
  collections: state => {
    let collections = [];
    for (const obj in state.posts) {
      if (state.posts.hasOwnProperty(obj)) {
        if (!collections.includes(state.posts[obj].collection)) {
          collections.push(state.posts[obj].collection);
        }
      }
    }
    return collections.sort()
  },
  typen: state => {
    let typen = [];
    for (const obj in state.posts) {
      if (state.posts.hasOwnProperty(obj)) {
        if (!typen.includes(state.posts[obj].typ)) {
          typen.push(state.posts[obj].typ);
        }
      }
    }
    return typen.sort()
  },
  subprojects: state => {
    let subprojects = [];
    for (const obj in state.posts) {
      if (state.posts.hasOwnProperty(obj)) {
          const subpArray = state.posts[obj].subproject
          if(subpArray) {
          for (let i = 0;i < subpArray.length;i++) {
            if (!subprojects.includes(subpArray[i])) {
              subprojects.push(subpArray[i]);
            }
          }
        }
      }
    }
    return subprojects.sort()
  },
  authors: state => {
    let authors = [];
    for (const obj in state.posts) {
      if (state.posts.hasOwnProperty(obj)) {
        if (!authors.includes(state.posts[obj].author.fullName)) {
          authors.push(state.posts[obj].author.fullName);
        }
      }
    }
    return authors.sort()
  },
  responsibles: state => {
    let responsibles = [];
    for (const obj in state.posts) {
      if (state.posts.hasOwnProperty(obj)) {
        for (const r in state.posts[obj].responsible) {
          if (!responsibles.includes(state.posts[obj].responsible[r].fullName)) {
            responsibles.push(state.posts[obj].responsible[r].fullName);
          }
        }
      }
    }
    return responsibles.sort()
  },
  tags: state => {
    let tags = [];
    for (const obj in state.posts) {
      if (state.posts.hasOwnProperty(obj)) {
        const tagsArray = state.posts[obj].tags
        if(tagsArray){
          for (let i = 0;i < tagsArray.length;i++) {
            if (!tags.includes(tagsArray[i].title)) {
              tags.push(tagsArray[i].title);
            }
          }
        }
      }
    }
    return tags.sort()
  },
}

//export store module
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})